import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { HomeService } from "./home.service";
// import { DoadorStore } from './doador.store';
// import { DoadorList, Pagination } from './doador';
import { SelectionModel } from "@angular/cdk/collections";
import { MatSort } from "@angular/material/sort";
import { fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { ColetorList, Pagination } from "./coletor/coletor";
import { ColetorStore } from "./coletor/coletor.store";
import { DadosFormStore } from "./dados-form/dados-form.store";
import { DadosFormList } from "./dados-form/dados-form";
import { MatDialog } from "@angular/material/dialog";
import { CpfModalComponent } from "./cpf-modal/cpf-modal.component";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  statusDaColeta: string;

  constructor(
    private homeService: HomeService,
    public store: DadosFormStore,
    private cpfBusca: MatDialog
  ) {}

  colunas: string[] = ["id", "nome", "cpf", "data", "finalizado", "editar"];
  dataSource: MatTableDataSource<DadosFormList>;
  selection = new SelectionModel<DadosFormList>(true, []);
  pageSizeArray: number[] = [5, 10, 20, 30, 50, 100];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("input", { static: true }) input: ElementRef;

  ngOnInit(): void {
    this.store.product$.subscribe((res) => {
      this.dataSource = new MatTableDataSource(res);
    });
  }

  formatarData(data: string) {
    if (data) {
      let dataFormatada = data.split("-");
      let dataA = dataFormatada[0];
      let dataM = dataFormatada[1];
      let dataD = dataFormatada[2];
      let dataNFormatada = `${dataD}/${dataM}/${dataA}`;
      return dataNFormatada;
    }
    return;
  }

  ngAfterViewInit() {
    fromEvent(this.input.nativeElement, "keyup")
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        tap((text) => {
          this.homeService
            .findAll(
              this.store.pageSize,
              this.store.pageIndex,
              this.input.nativeElement.value
            )
            .subscribe((res: Pagination<DadosFormList[]>) => {
              this.store.captacao = res.results;
              this.store.pageLenght = res.total;
              this.store.pageSearch = this.input.nativeElement.value;
            });
        })
      )
      .subscribe();
  }

  getNext(event) {
    console.log(event);
    this.store.pageSize = event.pageSize;
    this.store.pageIndex = event.pageIndex;

    this.homeService
      .findAll(
        this.store.pageSize,
        this.store.pageIndex,
        this.input.nativeElement.value
      )
      .subscribe((res) => {
        this.store.pageLenght = res.total;
        this.store.captacao = res.results;
      });
  }

  statusColeta(editarWeb): string {
    if (editarWeb == 0) {
      this.statusDaColeta = "Finalizada";
    } else {
      this.statusDaColeta = "Pendente";
    }

    return this.statusDaColeta;
  }

  ordenar() {
    this.store.product$.subscribe((res) => {
      let sort = res.sort((a, b) =>
        a.doador.nome > b.doador.nome
          ? 1
          : b.doador.nome > a.doador.nome
          ? -1
          : 0
      );
      this.dataSource = new MatTableDataSource(sort);
    });
  }

  openCPFBusca() {
    const cpf = this.cpfBusca.open(CpfModalComponent);

    cpf.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }
}
